<template>
    <div class="rechargeRule">
        <div class="ruleBox">
            <div class="ruleLeft">
                <div class="ruleList" v-for="(item,index) in form.ruleList" :key="index">
                    <p class="rule rule1">充值</p>
                    <p class="rule rule2">{{ item.rechargeAmount }}</p>
                    <p class="rule rule3">赠送</p>
                    <p class="rule rule4">{{ item.giveAmount }}</p>
                    <div>
                        <div class="couponsList" v-for="(i,d) in item.give" :key="d">
                            <el-radio v-model="i.couponUseScopeType" :label="1" @input="couponsBtn(1,i)">台费券</el-radio>
                            <el-radio v-model="i.couponUseScopeType" :label="2" @input="couponsBtn(2,i)">水机券</el-radio>
                            <el-select class="selectNum" v-model="i.couponNum" placeholder="请选择数量" clearable value-key="key">
                                <el-option :label="j" :value="j" v-for="(j,e) in i.selectList" :key="e"></el-option>
                            </el-select>
                            <el-select v-model="i.couponName" placeholder="请选择卡券" clearable>
                                <el-option :label="j.couponsNameDate" :value="j.couponName" v-for="(j,x) in i.couponsList" :key="x"></el-option>
                            </el-select>
                            <i class="el-icon-circle-plus" @click="addTimeRow(i,index)"></i>
                            <i class="el-icon-delete" v-if="item.give.length > 1" @click="delTimeRow(item,d)"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import requstsMethod from "common/const";
import { response } from "network/response";
export default {
    data () {
        return {
            radioNum: null,
            billiardsId: JSON.parse(this.$store.state.billiardsInfo).billiardsId,  //商户id
        }
    },
    props: ['form'],
    methods: {
        addTimeRow (item, index) {
            this.form.ruleList.map((res, i) => {
                if (index == i) {
                    let obj = {
                        couponUseScopeType: item.couponUseScopeType,
                        couponId: null,
                        couponName: '',
                        couponNum: 1,
                        selectList: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
                        couponsList: item.couponsList
                    }
                    res.give.push(obj)
                }
            })
        },
        delTimeRow (item, index) {
            item.give.map((res, i) => {
                if (i == index) {
                    item.give.splice(index, 1)
                }
            })
        },
        async couponsBtn (val, obj) {
            this.radioNum = val
            obj.couponName = ''
            obj.couponNum = 1
            const params = {
                billiardsId: this.billiardsId,
                useScopeType: val,
                pageNo: 1,
                pageSize: 100,
                useTime: this.form.endDate
            }
            const data = await response(requstsMethod.fun_Get_authorized_marketing_coupons_list, params)
            data.list.map(item => {
                item.validEndTime ? item.couponsNameDate = item.couponName + ' 有效期至' + item.validEndTime : item.couponsNameDate = item.couponName + ' 无限期'
            })
            if (val == 1) {
                obj.couponsList = data.list
            } else {
                obj.couponsList = data.list
            }
        },
        async configFn (close) {
            let array = []
            this.form.ruleList.map(item => {
                let obj = {
                    rechargeAmount: item.rechargeAmount,
                    giveAmount: item.giveAmount,
                    give: []
                }
                item.give.map(res => {
                    console.log(res, 'rrr');
                    res.couponsList.map(itemRes => {
                        if (res.couponName == itemRes.couponName) {
                            res.couponId = itemRes.couponId
                        }
                    })
                    let parObj = {
                        couponId: res.couponId,
                        couponNum: res.couponNum,
                    }
                    if (res.couponNum && res.couponId && res.couponNum !== '' && res.couponId !== '') {
                        obj.give.push(parObj)
                    }
                })
                array.push(obj)
            })
            const params = {
                billiardsId: this.billiardsId,
                id: this.form.activityId,
                name: this.form.name,
                remark: this.form.remark,
                status: null,
                templateType: this.form.type,
                startTime: this.form.creatDate,
                endTime: this.form.endDate,
                ruleConfig: {
                    rule: array
                },
            }
            console.log(params);
            const data = await response(requstsMethod.fun_service_authorized_activity_task_save, params)
            let text = ''
            this.addType == 'add' ? text = '添加' : text = '修改'
            if (data.pass) {
                this.$message({ message: `${text}成功`, type: 'success' });
                close()
            } else {
                this.$message({ message: `${text}失败，${data.errorLine[0].prompt}`, type: 'error' });
            }
        }
    }
}
</script>

<style lang="scss">
.rechargeRule {
    .ruleBox {
        display: flex;
        align-items: flex-start;
        justify-content: flex-start;
        .ruleLeft {
            .ruleList {
                display: flex;
                align-items: flex-start;
                margin: 20px 0;
                .rule {
                    color: #fff;
                    font-size: 14px;
                    height: 35px;
                    line-height: 35px;
                    margin-right: 15px;
                }
                .rule1 {
                    padding-left: 20px;
                }
                .rule2 {
                    min-width: 100px;
                    background-color: #323232;
                    border-radius: 4px;
                    padding: 0px;
                }
                .rule4 {
                    min-width: 100px;
                    background-color: #323232;
                    border-radius: 4px;
                    padding: 0px;
                }
                .couponsList {
                    margin: 0px 0 10px;
                }
                .el-radio {
                    .el-radio__label {
                        color: #fff;
                    }
                }
                .selectNum {
                    width: 120px !important;
                }
                .el-select {
                    width: 350px;
                    margin-right: 20px;
                    .el-input__inner {
                        height: 35px;
                        line-height: 35px;
                        color: #fff;
                        border: none;
                        background-color: #3e3e3e;
                        box-shadow: 0 0 5px #000 inset;
                    }
                }
                .el-icon-circle-plus {
                    font-size: 20px;
                    margin-right: 20px;
                    cursor: pointer;
                }
                .el-icon-circle-plus:hover {
                    color: #409eff;
                }
                .el-icon-delete {
                    font-size: 20px;
                    cursor: pointer;
                }
                .el-icon-delete:hover {
                    color: #fd4747;
                }
            }
        }
        .ruleRight {
            .couponsList {
                display: flex;
                align-items: center;
                margin: 20px 0;
            }
        }
    }
}
</style>